<template>
  <UIDialog
    :is-open
    :z-index
    title="Power Feature. Use With Caution!"
    class="power-mode-modal"
    @close="handleClose"
  >
    <ExclamationCircleIcon class="power-mode-modal__icon" />
    This is a powerful feature that allows you to perform irreversible actions.
    <template #footer>
      <UIButtonsGroup>
        <UIButton label="Cancel" variant="gray" fill="outlined" @click="handleClose" />
        <UIButton label="Turn On Power Mode" fill="outlined" @click="handleEnterPowerMode" />
      </UIButtonsGroup>
    </template>
  </UIDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ModalClass } from '@types'

import { UIDialog } from '@ui/modals'
import { UIButtonsGroup, UIButton } from '@ui/buttons'
import { useSettingsStore } from '@/store/settings'

import { ExclamationCircleIcon } from '@heroicons/vue/24/outline'

type Props = {
  modal: ModalClass<any>
}

type Emits = {
  close: []
  enterPowerMode: []
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const settingsStore = useSettingsStore()

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)

const handleClose = () => {
  props.modal.close()
  emit('close')
}

const handleEnterPowerMode = () => {
  settingsStore.setPowerMode(true)
  props.modal.close()
  emit('enterPowerMode')
}
</script>

<style>
.power-mode-modal {
  &__icon {
    @apply w-8 h-8;
    @apply shrink-0;
  }

  .ui-dialog__title {
    @apply text-red-700 dark:text-red-300;
  }

  .ui-dialog__content {
    @apply flex-row;
    @apply gap-2;
    @apply text-base sm:text-sm;
  }
}
</style>
